import RpIcon from "@/components/RpIcon";
import { KYC_STATUS } from "@/constant/Constant";
import { Stack, Box } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";

export default function KYCStatusHeader() {
  const { t } = useTranslation();
  const { user } = useSelector(state => state.user);

  let title = t(`kyc_status_${user.kycStatus}`);
  let subtitle = null;
  let icon = null;
  if (user.kycStatus == KYC_STATUS.KYC_STATUS_NOT_SUBMIT) {
    icon = 'info';
  } else if (user.kycStatus == KYC_STATUS.KYC_STATUS_SUBMITTED || user.kycStatus == KYC_STATUS.KYC_STATUS_RESUBMITTED) {
    icon = 'verifying';
    subtitle = t('on_review_your_applicant');
  } else if (user.kycStatus == KYC_STATUS.KYC_STATUS_APPROVED) {
    icon = 'check-circle-thin';
    title = t('approved');
  } else if (user.kycStatus == KYC_STATUS.KYC_STATUS_REJECT) {
    icon = 'close-circle';
  }

  return (
    <Stack direction={'column'} alignItems={'center'} gap={'16px'} sx={{marginBottom:'32px'}}>
      <RpIcon icon={icon} size={56}/>
      <Box className={'h2'}>{title}</Box>
      {!!subtitle && <p className={'small'}>{subtitle}</p>}
    </Stack>
  );
}
